import { WidgetController } from "../WidgetController";
import { WidgetTypes } from "../Widgets/WidgetTypes";
import { WidgetBase } from "../Widgets/WidgetBase";
import { BackgroundGridItem } from "../Components/BackgroundGridItem";

export class WidgetDragDrop {
    private dragElement: HTMLElement;
    private dragWidget: WidgetBase;
    private dragEnterCount: number;

    constructor(private controller: WidgetController, private container: HTMLElement) {
        // create div for drag operation
        this.dragElement = document.createElement("div");
        this.dragElement.classList.add("widget");
        this.dragElement.classList.add("d-none");
        this.container.appendChild(this.dragElement);
    }

    public startDragOnNewWidget(ev: DragEvent) {
        var type: WidgetTypes = parseInt((ev.currentTarget as HTMLElement).getAttribute("data-widget-type"));
        this.dragWidget = this.controller.createWidget(type);
        this.dragEnterCount = 0;
        if (this.dragWidget) {
            ev.dataTransfer.setData("mso/widget", this.dragWidget.guid);
            this.dragElement.classList.remove("d-none");
            this.dragElement.style.width = (this.dragWidget.minColSpan * this.controller.getCellWidth()) + "px";
            this.dragElement.style.height = (this.dragWidget.minRowSpan * this.controller.getCellHeight()) + "px";
            ev.dataTransfer.setDragImage(this.dragElement, 10, 10);
            setTimeout(() => {
                this.dragElement.classList.add("d-none");
            });
        } else {
            console.log("Could not create dragWidget - is the widget part of WidgetController.createWidget (switch statement)?")
        }

    }

    startDragOnExistingWidget(ev: DragEvent, element: HTMLElement, widget: WidgetBase) {
        ev.dataTransfer.setData("mso/widget", widget.guid);
        ev.dataTransfer.setDragImage(element, 10, 10);
        this.dragEnterCount = 0;
        this.dragWidget = widget;
        setTimeout(() => {
            element.classList.add("d-none");
        });
    }

    public drop(guid: string, column: number, row: number): void {
        if (this.dragWidget && this.dragWidget.guid == guid) {
            if (this.dragWidget.component) {
                this.dragWidget.column = column;
                this.dragWidget.row = row;
                this.dragWidget.setGridPosition();
            }
            else {
                this.container.appendChild(this.dragWidget.createComponent(column, row));
                this.controller.addWidget(this.dragWidget);
                this.dragWidget.enableEdit();
                this.dragWidget.showPopup();
            }
            this.dragWidget = null;
        }
    }

    public canDrop(column: number, row: number): boolean {
        if (this.dragWidget) {
            if ((column + this.dragWidget.colSpan) > (this.controller.NUM_COLS + 1) || (row + this.dragWidget.rowSpan) > (this.controller.NUM_ROWS + 1)) {
                return false;
            }
            return !this.controller.isWidgetInside(this.dragWidget.guid, column, row, this.dragWidget.colSpan, this.dragWidget.rowSpan);
        }
        return true;
    }

    public onDragEnterCell(bgWidget: BackgroundGridItem, ev: DragEvent) {
        console.log("dragenter " + this.dragEnterCount);
        if (ev.dataTransfer.types.indexOf("mso/widget") >= 0) {
            this.dragEnterCount++;
            if (this.canDrop(bgWidget.props.column, bgWidget.props.row)) {
                this.controller.hightlightDropItems(bgWidget.props.column, bgWidget.props.row, this.dragWidget.colSpan, this.dragWidget.rowSpan, true);
                ev.dataTransfer.dropEffect = "move";
            }
            else {
                this.controller.hightlightDropItems(bgWidget.props.column, bgWidget.props.row, this.dragWidget.colSpan, this.dragWidget.rowSpan, false);
                ev.dataTransfer.dropEffect = "none";
            }
            ev.preventDefault();
            ev.cancelBubble = true;
        }
    }

    public onDragLeaveCell(bgWidget: BackgroundGridItem, ev: DragEvent) {
        console.log("dragleave " + this.dragEnterCount);
        if (ev.dataTransfer.types.indexOf("mso/widget") >= 0) {
            this.dragEnterCount--;
            if (this.dragEnterCount <= 0) {
                this.controller.hightlightDropItems(bgWidget.props.column, bgWidget.props.row, this.dragWidget.colSpan, this.dragWidget.rowSpan, false);
            }
            ev.preventDefault();
            ev.cancelBubble = true;
        }
    }
}
